import type { BoxProps } from '@hover/blueprint';
import type React from 'react';

enum ToastType {
  ACTIVE = 'active',
  PASSIVE = 'passive',
}

interface GenericToast {
  id: string;
  title?: string;
  subtitle?: string;
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  onPress?: (toast: SliceOfToast, toasts: SliceOfToast[]) => void;
  offset?: number | string;
  type?: ToastType;
  backgroundColor?: BoxProps['backgroundColor'];
}

interface ActionableToast extends GenericToast {
  title: string;
  subtitle: string;
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  onPress: (toast: SliceOfToast, toasts: SliceOfToast[]) => void;
  type: ToastType.ACTIVE;
}

interface PassiveToastType extends GenericToast {
  title: string;
  offset?: number | string;
  type: ToastType.PASSIVE;
  spinner?: boolean;
}

type SliceOfToast = ActionableToast | PassiveToastType;

export { SliceOfToast, ActionableToast, PassiveToastType, ToastType };
